import { useNavigate } from "react-router";

export const useGoToGeolocation = () => {
  const navigate = useNavigate();
  return () => navigate("/geolocation");
};

export const useGoToRecommendedList = () => {
  const navigate = useNavigate();
  return () => navigate("/recommended-list");
};
